<script setup>
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { copyTextToClipboard } from 'shared/helpers/clipboard';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  link: { type: String, required: true },
  email: { type: String, default: '' },
});
const emit = defineEmits(['close']);
const { t } = useI18n();

const copyLink = async () => {
  await copyTextToClipboard(props.link);
  useAlert(t('AGENT_MGMT.INVITE_LINK.COPIED'));
};
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header
      :header-title="$t('AGENT_MGMT.INVITE_LINK.TITLE')"
      :header-content="$t('AGENT_MGMT.INVITE_LINK.DESC', { email })"
    />
    <div class="modal-content flex flex-col w-full gap-3">
      <div class="flex w-full gap-2">
        <input
          :value="link"
          type="text"
          readonly
          class="!mb-0 flex-1 font-mono text-xs"
          data-testid="agent-invite-link"
          @focus="$event.target.select()"
        />
        <Button
          icon="i-lucide-copy"
          :label="$t('AGENT_MGMT.INVITE_LINK.COPY')"
          @click="copyLink"
        />
      </div>
      <p class="text-body-main text-n-slate-11 mb-0">
        {{ $t('AGENT_MGMT.INVITE_LINK.NOTE') }}
      </p>
      <div class="flex flex-row justify-end w-full py-2">
        <Button
          faded
          slate
          :label="$t('AGENT_MGMT.INVITE_LINK.CLOSE')"
          @click="emit('close')"
        />
      </div>
    </div>
  </div>
</template>
